import React from 'react';
import { Component, PuzzleTextArea } from "puzzle";
import { TextAreaChangeEvent } from "@progress/kendo-react-inputs";
import { Field } from "../../../../UI/Field/Field";
import LimitedLetterCounter from "./LimitedLetterCounter";

export type PROPS = {
  templateDescription: string
};

export type STATE = {
  description: string
}

class TemplateDescription extends Component<PROPS, STATE> {

  maxLength: number = 150;

  static defaultProps = {
    templateDescription: ''
  };

  public state: STATE = {
    description: this.props.templateDescription
  };

  onChange = (event: TextAreaChangeEvent) => {
    let value = event.value;

    this.setState({
      description: value
    });
  };

  getValue = () => {
    let { description } = this.state;

    return description;
  };

  render() {
    const { description } = this.state;

    return (
      <Field>
        <PuzzleTextArea
          className={'tp-textarea-wrap'}
          name="description"
          label={this.translate('textAreaLabel')}
          labelClassName={'sr-only'}
          id="templateDescriptionTextArea"
          autoComplete={'off'}
          onChange={this.onChange}
          value={description}
          maxLength={this.maxLength}
        />
        <LimitedLetterCounter stringToCount={this.state.description}
                              maxCharacters={this.maxLength}></LimitedLetterCounter>
      </Field>
    );
  }
}

export default TemplateDescription;
